export default "__VITE_ASSET__D4j9h_Wa__"